module.exports = __webpack_public_path__ + "img/Hardcover.50c156b9.png";